import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Children, Component } from 'react';
import Button from '../Button';
import Card from '../Card';
import Divider from '../Divider';
import StackView from '../StackView';
import PagerView from '../PagerView';
import StepperProgress from '../StepperProgress';
import Text from '../Text';
import Step from './Step';
import WizardContext from './WizardContext';

var _ref = /*#__PURE__*/React.createElement(Divider, null);

var Wizard = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Wizard, _Component);

  function Wizard() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeStepIndex: 0,
      payload: _this.props.initialPayload,
      steps: [],
      totalSteps: -1,
      sendingPayload: false
    });

    _defineProperty(_assertThisInitialized(_this), "setPayload", function (newPayload, cb) {
      _this.setState(function (state) {
        return {
          payload: _objectSpread(_objectSpread({}, state.payload), newPayload)
        };
      }, cb);
    });

    _defineProperty(_assertThisInitialized(_this), "setSteps", function (getSteps) {
      _this.setState(function (state) {
        var nextSteps = getSteps(state.steps);
        return {
          steps: nextSteps,
          totalSteps: nextSteps.length
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addStep", function (step) {
      _this.setSteps(function (steps) {
        return [].concat(steps, [step]);
      });

      return function () {
        _this.setSteps(function (steps) {
          return steps.filter(function (previousStep) {
            return previousStep.name !== step.name;
          });
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      if (_this.props.onSubmit) {
        var _complete = function _complete() {
          return _this.setState({
            sendingPayload: false
          });
        };

        _this.setState({
          sendingPayload: true
        });

        _this.props.onSubmit(_this.state.payload, _complete);
      }
    });

    return _this;
  }

  var _proto = Wizard.prototype;

  _proto.isCurrentStepValid = function isCurrentStepValid() {
    var _this$state = this.state,
        activeStepIndex = _this$state.activeStepIndex,
        payload = _this$state.payload,
        steps = _this$state.steps;
    var currentStep = steps[activeStepIndex];
    return currentStep && currentStep.valid ? currentStep.valid(payload) : true;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        autoFocus = _this$props.autoFocus,
        backButtonProps = _this$props.backButtonProps,
        buttonProps = _this$props.buttonProps,
        cancelButtonProps = _this$props.cancelButtonProps,
        children = _this$props.children,
        footerProps = _this$props.footerProps,
        initialPayload = _this$props.initialPayload,
        nextButtonProps = _this$props.nextButtonProps,
        nextButtonTitle = _this$props.nextButtonTitle,
        onCancel = _this$props.onCancel,
        onSubmit = _this$props.onSubmit,
        renderProgress = _this$props.renderProgress,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["autoFocus", "backButtonProps", "buttonProps", "cancelButtonProps", "children", "footerProps", "initialPayload", "nextButtonProps", "nextButtonTitle", "onCancel", "onSubmit", "renderProgress"]);

    var _this$state2 = this.state,
        activeStepIndex = _this$state2.activeStepIndex,
        sendingPayload = _this$state2.sendingPayload,
        steps = _this$state2.steps,
        totalSteps = _this$state2.totalSteps;
    return /*#__PURE__*/React.createElement(WizardContext.Provider, {
      value: {
        activeStepIndex: this.state.activeStepIndex,
        addStep: this.addStep,
        setPayload: this.setPayload,
        payload: this.state.payload,
        totalSteps: this.state.totalSteps
      }
    }, /*#__PURE__*/React.createElement(StackView, _extends({
      alignment: "center",
      minWidth: 48,
      maxWidth: 96
    }, restProps), renderProgress ? renderProgress({
      activeStepIndex: activeStepIndex,
      steps: steps,
      totalSteps: totalSteps
    }) : /*#__PURE__*/React.createElement(StepperProgress, {
      width: "80%",
      paddingTop: 6,
      paddingBottom: 4,
      activeStepIndex: activeStepIndex
    }, steps.map(function (step, index) {
      return /*#__PURE__*/React.createElement(StepperProgress.Step, {
        key: index,
        renderEnd: /*#__PURE__*/React.createElement(Text, {
          align: "center",
          marginTop: 2
        }, step.name)
      });
    })), /*#__PURE__*/React.createElement(Card, {
      spacing: _ref,
      elevation: 1
    }, /*#__PURE__*/React.createElement(PagerView, {
      activeViewIndex: activeStepIndex,
      autoFocus: autoFocus
    }, Children.map(children, function (child, index) {
      return /*#__PURE__*/React.createElement(PagerView.View, {
        key: index
      }, child);
    })), /*#__PURE__*/React.createElement(StackView, _extends({
      axis: "horizontal",
      distribution: activeStepIndex > 0 ? 'space-between' : 'end',
      padding: 1,
      spacing: 1
    }, footerProps), activeStepIndex === 0 && onCancel && /*#__PURE__*/React.createElement(Button, _extends({
      disabled: sendingPayload,
      onClick: onCancel,
      size: "lg",
      title: "Cancel",
      variant: "naked"
    }, buttonProps, cancelButtonProps)), activeStepIndex > 0 && /*#__PURE__*/React.createElement(Button, _extends({
      disabled: sendingPayload,
      iconLeft: {
        name: 'caret-left'
      },
      onClick: function onClick() {
        return _this2.setState({
          activeStepIndex: activeStepIndex - 1
        });
      },
      size: "lg",
      title: "Back",
      variant: "naked"
    }, buttonProps, backButtonProps)), /*#__PURE__*/React.createElement(Button, _extends({
      disabled: !this.isCurrentStepValid(),
      onClick: function onClick() {
        return activeStepIndex >= totalSteps - 1 ? _this2.handleSubmit() : _this2.setState({
          activeStepIndex: activeStepIndex + 1
        });
      },
      size: "lg",
      spinner: sendingPayload,
      theme: "primary",
      title: nextButtonTitle({
        activeStepIndex: activeStepIndex,
        steps: steps,
        totalSteps: totalSteps
      })
    }, buttonProps, nextButtonProps))))));
  };

  return Wizard;
}(Component);

_defineProperty(Wizard, "Step", Step);

_defineProperty(Wizard, "defaultProps", {
  autoFocus: true,
  initialPayload: {},
  nextButtonTitle: function nextButtonTitle(_ref2) {
    var activeStepIndex = _ref2.activeStepIndex,
        steps = _ref2.steps,
        totalSteps = _ref2.totalSteps;
    return activeStepIndex >= totalSteps - 1 ? 'Finish' : 'Next';
  }
});

export default Wizard;